/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	RecruiterBookingInstantPathParams,
	RecruiterBookingInstantResponse,
} from '../types/RecruiterBookingInstant'

/**
 * POST /interview-scheduling/campaigns/:campaignId/candidates/:candidateId/instant-meeting
 * @see backend/nexus/modules/InterviewScheduling/Http/Controllers/RecruiterBookingController.php RecruiterBookingController::instant
 */
export async function recruiterBookingInstant(
	campaignId: RecruiterBookingInstantPathParams['campaignId'],
	candidateId: RecruiterBookingInstantPathParams['candidateId'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<RecruiterBookingInstantResponse>> {
	return axiosInstance.post(
		`/interview-scheduling/campaigns/${campaignId}/candidates/${candidateId}/instant-meeting`,
		undefined,
		config,
	)
}
